import { render, staticRenderFns } from "./ai_panel.vue?vue&type=template&id=050ca20a"
import script from "./ai_panel.vue?vue&type=script&lang=js"
export * from "./ai_panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports